<template>
  <b-container fluid v-resize="onResize" v-bind:style="{height:containerHeight+'px'}">
    <b-row class="full-height">
        <b-col cols="12" md="4" class="px-0 full-height no-print">
            <div class="overflow full-height">            
                <b-navbar toggleable type="light" variant="light" sticky>
                    <div class="d-flex flex-row w-100">
                        <b-form-input class="flex-grow-1" type="search" size="sm" placeholder="Search" v-model="filter.searchParam"/>
                        <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" right no-caret>
                            <template #button-content >
                                <i class="fas fa-filter"></i>
                            </template>
                            <b-dropdown-item @click='onFilter("", "All")' :active='filter.activeSts === "All"'>All</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("New", "New")' :active='filter.activeSts === "New"'>New</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("Confirmed", "Confirmed")' :active='filter.activeSts === "Confirmed"'>Confirmed</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("Preparing", "Preparing")' :active='filter.activeSts === "Preparing"'>Preparing</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("Pack", "Pack")' :active='filter.activeSts === "Pack"'>Pack</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("Ready", "Ready")' :active='filter.activeSts === "Ready"'>Ready</b-dropdown-item>
                            <b-dropdown-item @click='onFilter("Closed Rejected  Cancelled_Customer Cancelled_Staff", "Completed")' :active='filter.activeSts === "Completed"'>Completed</b-dropdown-item>
                        </b-dropdown>
                        <b-form-datepicker class="datePickerDiv" v-model="dayData" size="sm" :max="maximumDate" locale="en" right/>
                        <b-button size="sm" variant="link" @click="getCurrentDay"><i class="far fa-calendar"></i></b-button>
                    </div>                    
                </b-navbar>
                <order-single
                        class="clickAble"
                        v-for="(order) in sortedOrders"
                        :key="order.id"
                        :value="order"
                        @on-order-click="onOrderClick" />  
            </div>
        </b-col>
        <b-col md="8" class="d-none d-md-block orderDetail">
            <order-deatils />
        </b-col>
    </b-row>    
  </b-container>
</template>

<script>

import { mapState } from 'vuex'
import OrderDeatils from "@/components/portal/OrderDetails"
import OrderSingle from "@/components/portal/OrderSingle"

export default {
    props : [ "appbus" ],
    components : {
        OrderDeatils, OrderSingle
    },
    computed : { 
		...mapState({
            viewingOrder:'viewingOrder',
            store: 'store',
            selectedLocation:'selectedLocation',
            stateOrders:'stateOrders',
		}),
        getOS() {
            return this.$store.getters.getOrderStatus
        },
        timeZone() {
          return this.$store.getters.timeZone
        },
        sortedOrders() {
            let searchAndFilter = ({name, status, orderNumber, phone}) =>  {
                        let searchParam = this.filter.searchParam.trim().toLowerCase()
                        
                        let hasSearchQuery = !searchParam ||
                        (name.toLowerCase().indexOf(searchParam) >= 0 ||
                        `${orderNumber}`.indexOf(searchParam) >= 0 ||
                        phone.toLowerCase().indexOf(searchParam) >= 0 ) ;                                                                    

                        let hasFilter = !this.filter.filter.trim() || this.filter.filter.indexOf(status) >= 0                                                            
                        return hasSearchQuery && hasFilter
                    }                 
            let comparator = (a, b) => {
                let statusA = this.getOS[a.status]
                let statusB = this.getOS[b.status]
                return statusA.priority - statusB.priority
            };
            return this.orders.filter(searchAndFilter).sort(comparator)
        }
    },
    data() {
        return {
            isMobile : false,
            containerHeight : 0,
            orders : this.stateOrders,
            dayData : this.moment().format("YYYY-MM-DD"),
            maximumDate : this.moment().toDate(),
            watchDogTimer:null,
            filter : { searchParam : "" , filter : "" , activeSts : "All" }
        }
    },
    watch : {
        selectedLocation: {
            deep: true,
            immediate: true,
            handler() {
                this.dayData = this.moment().tz(this.timeZone).format("YYYY-MM-DD"),
                this.maximumDate = this.moment().tz(this.timeZone).toDate(),
                this.getOrders()
                this.watchDog()     
            }
        },
        stateOrders : {
            deep : true,
            immediate : true,
            handler() {
                this.orders = this.stateOrders
            }
        },
        dayData : {
            handler(){
                this.getOrders()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {	
            this.getOrders()
            this.watchDog()
            if(this.appbus) {
                this.appbus.$on("orderStatus", () => {
                    // console.log(data)
                    this.getOrders()
                    this.fetchOrderDetail()                   
                })
            }
        })
    },
    created(){
        
    },
    destroyed(){
        if(this.appbus) {
            this.appbus.$off('orderStatus');
        }
    },
    methods: {
        watchDog(){
            let time = this.moment().tz(this.timeZone)
            let nextDayMidNight = this.moment().tz(this.timeZone).add(1, "days").startOf('day')
            if(this.watchDogTimer){
                clearTimeout(this.watchDogTimer)
            }
            const executeAfter = nextDayMidNight.diff(time)
            console.log(`It will Execute After ${this.moment.duration(executeAfter).asMinutes()} minutes`)
            this.watchDogTimer = setTimeout(this.getCurrentDay, executeAfter)
        },
        onResize() {
            let navheader = document.getElementById('navheader')            
            if(navheader){
                this.containerHeight = window.innerHeight - navheader.offsetHeight - 10;
            }
            this.isMobile = window.matchMedia('(max-width: 767px)').matches
        },
        getCurrentDay() {
            this.dayData = this.moment().tz(this.timeZone).format("YYYY-MM-DD")
            this.getOrders()
        },        
        getOrders() {
            const isToday = this.moment().tz(this.timeZone).format("YYYY-MM-DD") === this.dayData
            let req = { sort : true , date : isToday ? "current" : this.dayData }
            this.$store.dispatch("apiGetOrders", req)
                       .then(({status, res, error}) => {
                           if(status) {
                               this.$store.commit("updateStateOrders", res)
                           } else {
                               console.log("apiGetOrders-E", error)
                           }
                       })
                       .catch(e=>{ 
                            console.log("apiGetOrders-E", e)
                        })
        },
        onOrderClick({_id}) {
            if(this.isMobile) {
                this.$router.push({name: 'OrderDetail', params: { orderId: _id }})
            }
        },
        onFilter(filter, sts) {
            this.filter.filter = filter
            this.filter.activeSts = sts
        },
        fetchOrderDetail() {
            if(!this.viewingOrder) return
            this.$store.dispatch("apiGetSingleOrder", this.viewingOrder)
                       .then(({status, res, error}) => {
                           if(status) {
                               this.$store.commit('selectViewingOrder', res)
                           } else {
                               console.log("apiGetSingleOrder-E", error)
                           }
                       })
                       .catch(e=>{ 
                            console.log("apiGetSingleOrder-E", e)
                       })
        }
    }
}
</script>
<style lang="scss" scoped>
    .overflow {
        overflow: auto;
    }
    .full-height {
        height: 100%;
    }

    .datePickerDiv {
        width : unset !important;
        border: none !important;
        background: transparent !important;
    }
    .datePickerDiv ::v-deep label{
        display: none;
    }
    
    .datePickerDiv ::v-deep .dropdown-menu {
        // overflow : auto;
        // height : 250px;
    }

    @media print {
        .orderDetail {
            width: 100% !important;
            max-width: unset;
            flex: unset;
        }
    }
</style>